export const pagedResponse = {
  items: [],
  page: 0,
  pageSize: 0,
  totalItems: 0,
  totalPages: 0,
}

export const pagedPaymentResponse = {
  ...pagedResponse,
  statistics: {
    count: 0,
    net: 0,
    gross: 0,
  },
}
